import React from "react";
import { CloseIcon } from "../util/Icons";

export default function SocialFeedTutorial() {
  return (
    <div className="bg-white w-full max-w-xl h-fit min-h-[500px] md:min-h-[600px] max-h-[90vh] flex flex-col p-4 md:p-10 rounded-2xl gap-8 shadow-2xl relative overflow-y-auto">
      <button data-close className="absolute top-4 right-4 p-2 hover:bg-slate-100 rounded-full transition-colors flex items-center justify-center z-10">
        <CloseIcon className="pointer-events-none text-slate-500" />
      </button>
      <div className="flex flex-col gap-8 md:gap-12 flex-1 justify-center">
        <h3 className="text-center font-bold text-2xl text-slate-800 px-4">Let's get you started!</h3>
        <p className="text-center text-slate-600 font-medium text-lg">Please watch this video to make the most out of your challenge!</p>
        <div
          //   style="padding:75% 0 0 0;position:relative;"
          // className="relative pt-11"
          className="w-full h-full flex flex-col justify-center"
        >
          <iframe
            src="https://player.vimeo.com/video/1199518020?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            //   style="position:absolute;top:0;left:0;width:100%;height:100%;"
            className="w-full aspect-video"
            title="MCC - New Onboarding"
          ></iframe>
        </div>
        <script src="https://player.vimeo.com/api/player.js"></script>
      </div>
    </div>
  );
}
